export default "__VITE_ASSET__CnWogNy8__"